import { SERVICE_DEFS, ServiceKey } from '../config/services';

export type HubRoute =
  | { kind: 'home' }
  | { kind: 'settings'; tab?: string }
  | { kind: 'service'; serviceKey: ServiceKey };

const SERVICE_BY_PATH: Record<string, ServiceKey> = Object.fromEntries(
  Object.entries(SERVICE_DEFS).map(([key, def]) => [def.href.replace(/^\//, ''), key as ServiceKey])
);

export function parseHashRoute(hash: string): HubRoute {
  const raw = (hash || '').replace(/^#/, '').replace(/^\//, '');
  if (!raw || raw === 'home') return { kind: 'home' };
  if (raw.startsWith('settings')) {
    const tab = raw.split('/')[1];
    return { kind: 'settings', tab: tab || undefined };
  }
  if (raw.startsWith('app/')) {
    const slug = raw.slice(4).split('/')[0];
    const key = SERVICE_BY_PATH[slug];
    if (key) return { kind: 'service', serviceKey: key };
  }
  return { kind: 'home' };
}

export function hashForRoute(route: HubRoute): string {
  if (route.kind === 'home') return '';
  if (route.kind === 'settings') return route.tab ? `#settings/${route.tab}` : '#settings';
  const href = SERVICE_DEFS[route.serviceKey].href.replace(/^\//, '');
  return `#app/${href}`;
}
